export const APP_VERSION = "1.0.5";
export const DEVICE_TYPE = "web";
export const DESKTOP_LINK = "https://www.rooter.gg";
export const SITE_URL = "https://m.rooter.gg";

import configs from "./env_config";
export { configs };

// Google analytics
export const GA_ID = "UA-105786949-14";
export const GTM_ID = "GTM-WSWFQL7";

export const APP_MAX_WIDTH = "600px";
export const AGORA_APP_ID = "8862728d019143418dd9944df0f3acf5";
export const DEFAULT_AVATAR_LOGO = "/default_avatar.svg";
export const DEFAULT_FEED_IMAGE = "/default_feed.svg";
export const DEFAULT_AUDIO_IMAGE = "/new_design/audio_wave.svg";
export const DOWNLOAD_LINK_HEADER = "https://rooter.app.link/3tsHsly8k1";
export const DOWNLOAD_LINK_HAMBURGER = "https://rooter.app.link/VjNg0Ku8k1";
export const DOWNLOAD_LINK_CATFISH = "https://rooter.app.link/YXWPZ5v0Qcb";
export const user_loginRequest = {
	pushId   : "webPushId",
	locale   : "en",
	campaign : "webCampaign"
};
export const PAYTM_MINI_APP = "PAYTM_MINI_APP";
export const PAYTM_TAB = "PAYTM_TAB";
export const PAYTM_MINI_APP_TITLE = "Rooter - India's Biggest Gaming & Sports App";

// Singular Links
export const SNG_BANNER_LINK = "https://rooter.sng.link/B46b2/ftj4/62np";
export const SNG_POPUP_LINK = "https://rooter.sng.link/B46b2/gef8/k996";
export const SNG_HEADER_LINK = "https://rooter.sng.link/B46b2/hvz5/7u6p";
export const SNG_STICKY_LINK = "https://rooter.sng.link/B46b2/lrno/g2oy";
export const SNG_ERROR_LINK = "https://rooter.sng.link/B46b2/48fr/7fji";
export const SNG_DOWNLOAD_LINK = "https://rooter.sng.link/B46b2/unb7/m5aj";

// testing
//  22324807338 HealthEngine.web [300,250]
// '/6355419/Travel', [728, 90]

// testing 2
// /21687718510/feed_native_test_unit', ['fluid'],

// feeds ad unit
// 21687718510/Home_Page_Feed_Native_Banner_Web, ['fluid'], "div-gpt-ad-1659097394921-0"

// chat add unit
// 21687718510/Native_ChatBanner_Web [ "fluid" ]

// carousel add unit
// '/21687718510/Home_Page_Carousel_Web', ['fluid'], 'div-gpt-ad-1659428762121-0'
export const googleDFPAdsConfig = {
	feed: {
		ADS_PLACEMENT_COUNT : 4,
		networkId           : "21687718510",
		adUnit              : "Home_Page_Feed_Native_Banner_Web",
		// adUnit              : "feed_native_test_unit",
		// networkId           : "22324807338",
		// adUnit              : "HealthEngine.web",
		slotId              : "div-gpt-ad-1659097394921-0",
		sizes               : [
			[ "fluid" ]
			// [ 300, 250 ]
		]
	},
	testAd: {
		ADS_PLACEMENT_COUNT : 4,
		// networkId           : "22324807338",
		// adUnit              : "HealthEngine.web",
		networkId           : "21687718510",
		adUnit              : "feed_native_test_unit",
		slotId              : "div-gpt-ad-1659097394921-0",
		sizes               : [
			[ "fluid" ]
			// [ 300, 250 ]
		]
	},
	chat: {
		networkId : "21687718510",
		adUnit    : "Native_ChatBanner_Web",
		slotId    : "div-gpt-ad-1659097394998-0",
		sizes     : [
			[ "fluid" ]
		]
	},
	carousel: {
		networkId : "21687718510",
		adUnit    : "Home_Page_Carousel_Web",
		slotId    : "div-gpt-ad-1659428762121-0",
		sizes     : [
			[ "fluid" ]
		]
	}
};

// prod
// networkId: "21687718510",
// adUnit: "Home_Page_Feed_Native_Banner_Web",
// export const googleDFPAdsConfig = {
// ADS_PLACEMENT_COUNT : 5,
// networkId           : "21687718510",
// adUnit              : "Home_Page_Feed_Native_Banner_Web",
// slotId              : "div-gpt-ad-1650536516479-0-",
// sizes               : [
// [ "fluid" ]
// ]
// };

export const adBannerList = [
	{
		"rooterData": {
			"href": "https://images.rooter.gg/rooter-content-new/incoming/usecoinsandredeem_qoxb.png"
		}
	},
	{
		"rooterData": {
			"href": "https://images.rooter.gg/rooter-content-new/incoming/winbgmicash_dhis.png"
		}
	},
	{
		"rooterData": {
			"href": "https://images.rooter.gg/rooter-content-new/incoming/watchjonathongaming_yuhg.png"
		}
	},
	{
		"rooterData": {
			"href": "https://images.rooter.gg/rooter-content-new/incoming/watchlokeshgamer_xuyh.png"
		}
	}
];

export const thirdPartyUiConfig = {
	DOWNLOAD_APP_BUTTON               : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	CLEVERTAP_SUBSCRIBE_NOTIFICATIONS : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	ADD_HOMESCREEN                    : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	JOIN_TELEGRAM                     : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	LOGIN_BUTTON                      : { PAYTM_MINI_APP: true, PAYTM_TAB: false },
	LOGOUT_BUTTON                     : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	INVITE_BUTTON                     : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	GO_LIVE_BUTTON                    : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	DOWNLOAD_MEDIA_BUTTON             : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	BECOME_BROADCASTER                : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	SCORECARD_INTERESTIAL_POPUP       : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	RTMP_GO_LIVE                      : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	ENTER_FULLSCREEN                  : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	AD_COMPONENTS                     : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	ADD_PWA                           : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	GO_BACK_BUTTON                    : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	MATCH_ODDS                        : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	MATCHCARD_BUTTONS                 : { PAYTM_MINI_APP: true, PAYTM_TAB: false },
	TERMS_AND_PRIVACY                 : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	ABOUT_US                          : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	FANTASY_TAB                       : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	FANTASY_BUTTON                    : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	EXCLUSIVE_FEED                    : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	FANTASY_EXCLUSIVE_FEED            : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	CAROUSEL_BANNER                   : { PAYTM_MINI_APP: false, PAYTM_TAB: true },
	USER_SOCIAL_MEDIA_LINKS           : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	FANTASY_TEAMS                     : { PAYTM_MINI_APP: false, PAYTM_TAB: false },
	SIGN_IN_BUTTON                    : { PAYTM_MINI_APP: true, PAYTM_TAB: false },
	HAMBURGER_BUTTON                  : { PAYTM_MINI_APP: true, PAYTM_TAB: false },
	HOME_BUTTON                       : { PAYTM_MINI_APP: true, PAYTM_TAB: false },
	DOWNLOAD_HEADER_BUTTON            : { PAYTM_MINI_APP: false, PAYTM_TAB: true }
};

// "QuotaExceededError"
export const filteredSentryErrors = [
	"Non-Error promise rejection captured",
	"Non-Error exception captured",
	"QuotaExceededError",
	"Remote Config: Error thrown when opening storage",
	"Installations: Could not process request. Application offline",
	"Cannot read property 'getItem' of null",
	"SecurityError: Failed to read the 'localStorage' property from 'Window'",
	"AUDIO_CONTEXT_NOT_SUPPORTED",
	"Cannot set property 'loading' of undefined",
	"InvalidStateError: An attempt was made to use an object that is not, or is no longer, usable",
	"TimeoutError: Transaction timed out due to inactivity",
	"SecurityError: Blocked a frame with origin",
	"Cannot read property 'options' of undefined",
	"NotSupportedError: Failed to construct 'RTCPeerConnection'",
	"require is not defined",
	"Cannot read property 'parentNode' of null",
	"Object function Object() { [native code] } has no method 'setPrototypeOf'",
	"NotFoundError: IDBDatabase.transaction: 'app_namespace_store' is not a known object store name",
	"t.debug is not a function",
	"Cannot read property 'createObjectStore' of undefined",
	"Cannot read property 'getReadModeRender' of undefined",
	"Cannot read property 'getReadModeExtract' of undefined",
	"Cannot read property 'getReadModeConfig' of undefined",
	"InvalidAccessError: Failed to execute 'setTimeout' on 'Window'",
	"SecurityError: Failed to read the 'cookie' property from 'Document'",
	"Failed to get document because the client is offline.",
	"crypto.getRandomValues() not supported",
	"vid_mate_check is not defined",
	"Cannot redefine property: colorDepth",
	"Cannot redefine property: MaxTouchPoints",
	"Cannot redefine property: msMaxTouchPoints",
	"Cannot redefine property: languages",
	"Cannot redefine property: pixelDepth",
	"Cannot redefine property: language"
];

export const filteredPaytmErrors = [
	"Non-Error promise rejection captured",
	"Non-Error exception captured",
	"QuotaExceededError",
	"Cannot read property 'getItem' of null",
	"SecurityError: Failed to read the 'localStorage' property from 'Window'",
	"AUDIO_CONTEXT_NOT_SUPPORTED",
	"Cannot set property 'loading' of undefined",
	"InvalidStateError: An attempt was made to use an object that is not, or is no longer, usable",
	"TimeoutError: Transaction timed out due to inactivity",
	"SecurityError: Blocked a frame with origin",
	"Cannot read property 'options' of undefined",
	"NotSupportedError: Failed to construct 'RTCPeerConnection'",
	"require is not defined",
	"Cannot read property 'parentNode' of null",
	"Object function Object() { [native code] } has no method 'setPrototypeOf'",
	"NotFoundError: IDBDatabase.transaction: 'app_namespace_store' is not a known object store name",
	"t.debug is not a function",
	"Cannot read property 'createObjectStore' of undefined",
	"Cannot read property 'getReadModeRender' of undefined",
	"Cannot read property 'getReadModeExtract' of undefined",
	"Cannot read property 'getReadModeConfig' of undefined",
	"InvalidAccessError: Failed to execute 'setTimeout' on 'Window'",
	"SecurityError: Failed to read the 'cookie' property from 'Document'",
	"Failed to get document because the client is offline.",
	"crypto.getRandomValues() not supported",
	"vid_mate_check is not defined",
	"Cannot redefine property: colorDepth",
	"Cannot redefine property: MaxTouchPoints",
	"Cannot redefine property: msMaxTouchPoints",
	"Cannot redefine property: languages",
	"Cannot redefine property: pixelDepth",
	"Cannot redefine property: language"
];

export const lightTheme = {
	primaryColor   : "#ffffff",
	secondaryColor : "linear-gradient(to top, #439aff, #126bd5)",
	inputBgColor   : "#f3f3f3",
	inputColor     : "#797979",
	color          : "#000000",
	borderColor    : "#e7e7e7",
	iconColor      : "#126bd5",
	boxShadow      : "rgba(0, 0, 0, 0.16) 0px 0px 6px 0px"
};

